import { create } from 'zustand';
import { SetupStepItem, SidebarMenuItem } from '../types';

export interface SidebarState {
  menuItems: SidebarMenuItem[] | [];
  setMenuItems: (items: SidebarMenuItem[]) => void;
  menuMySidebarItems: SidebarMenuItem[];
  setMenuMySidebarItems: (items: SidebarMenuItem[]) => void;
  entityMenuItems: SidebarMenuItem[] | [];
  setEntityMenuItems: (items: SidebarMenuItem[]) => void;
  showEntityMenu: boolean;
  setShowEntityMenu: (show: boolean) => void;
  setupStepItems: SetupStepItem[] | [];
  setSetupStepItems: (items: SetupStepItem[]) => void;
  backText: string;
  backPath: string;
  setBackText: (path: string) => void;
  setBackPath: (path: string) => void;
}

const initialState = {
  menuItems: [],
  menuMySidebarItems: [],
  entityMenuItems: [],
  showEntityMenu: false,
  setupStepItems: [],
  backText: '',
  backPath: '',
};

export const useSidebarStore = create<SidebarState>()((set) => ({
  ...initialState,
  setMenuItems: (newItems) => set((/* state */) => ({ menuItems: newItems })),
  setMenuMySidebarItems: (newItems) => set((/* state */) => ({ menuMySidebarItems: newItems })),
  setEntityMenuItems: (newItems) => set((/* state */) => ({ entityMenuItems: newItems })),
  setShowEntityMenu: (show) => set((/* state */) => ({ showEntityMenu: show })),
  setSetupStepItems: (newItems) => set((/* state */) => ({ setupStepItems: newItems })),
  setBackText: (newText) => set((/* state */) => ({ backText: newText })),
  setBackPath: (newPath) => set((/* state */) => ({ backPath: newPath })),
}));
